import { useSearchParams } from "react-router-dom";
import SEO from "@/components/SEO";
import { Btn, Eyebrow } from "@/components/primitives";
import { Reveal } from "@/components/motion/Reveal";
import { brand } from "@/content/site";
import { CalendarCheck } from "lucide-react";

const PILOT_META = {
  "energy-growth-pilot": {
    label: "Energy Growth Pilot",
    backTo: "/energy-growth-pilot",
    backLabel: "Back to Energy Growth Pilot",
  },
  "installer-growth-pilot": {
    label: "Installer Growth Pilot",
    backTo: "/for/installer-growth-pilot",
    backLabel: "Back to Installer Growth Pilot",
  },
};

export default function DiscoveryThankYou() {
  const [params] = useSearchParams();
  const slotLabel = params.get("slot") || "";
  const pilotSlug = params.get("pilot") || "energy-growth-pilot";
  const pilot = PILOT_META[pilotSlug] || PILOT_META["energy-growth-pilot"];

  return (
    <>
      <SEO
        title={`Booking Confirmed | ${pilot.label} | Green Circle Group`}
        description="Your Discovery Call is booked. You'll get a calendar invite by email shortly."
        path="/discovery/thank-you"
        noindex
      />
      <section
        data-testid="discovery-thankyou"
        className="relative bg-white pt-28 md:pt-36 pb-24 min-h-screen"
      >
        <div className="mx-auto max-w-2xl px-5 sm:px-8 text-center">
          <Reveal>
            <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-forest text-lime">
              <CalendarCheck className="h-8 w-8" />
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="mt-6">
              <Eyebrow className="justify-center">You&apos;re booked in</Eyebrow>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05] text-forest text-balance">
              Thanks — see you soon.
            </h1>
          </Reveal>
          {slotLabel && (
            <Reveal delay={0.12}>
              <div
                data-testid="thankyou-slot"
                className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-forest text-white px-6 py-4"
              >
                <CalendarCheck className="h-5 w-5 text-lime" />
                <div className="text-left">
                  <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-lime">
                    Your Discovery Call
                  </p>
                  <p className="mt-0.5 font-extrabold">{slotLabel}</p>
                </div>
              </div>
            </Reveal>
          )}
          <Reveal delay={0.15}>
            <p className="mt-8 text-lg text-mid-neutral leading-relaxed">
              Your 30-minute {pilot.label} Discovery Call is confirmed. A
              calendar invite is on its way to your email inbox. If you need
              to change or cancel, reply to that invite or email us anytime.
            </p>
            <p className="mt-4 text-mid-neutral">
              Any questions? Reach us at{" "}
              <a
                href={`mailto:${brand.email}`}
                className="font-semibold text-forest underline"
              >
                {brand.email}
              </a>
              .
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <Btn to={pilot.backTo} data-testid="discovery-thankyou-back-cta">
                {pilot.backLabel}
              </Btn>
              <Btn to="/" variant="secondary" withArrow>
                Explore Green Circle Group
              </Btn>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
